// extracted by mini-css-extract-plugin
module.exports = {"RealizationBoxesList":"RealizationBoxesList_RealizationBoxesList__1I1ee","loadMore":"RealizationBoxesList_loadMore___24ti"};